const initialStateModal = {
    isOpen: false,
    HeadItem: [],
    FooterItem: [],
    children: '',
    onClose: () => {
    },
};

const initialState = {
    activeModals: initialStateModal,
    activeExtraModals: initialStateModal,
    cacheOld: [],
    cacheNext: [],
};

export const rightModalReducer = function (state = initialState, action) {
    switch (action.type) {
        case 'openRightModal': {
            let data = {...state};
            if (!Object.equals(data.activeModals.children, action.children)){
                if (data.activeModals.isOpen) {
                    data.cacheOld.push(data.activeModals);
                }
                data.cacheNext = [];
                data.activeModals = {
                    isOpen: true,
                    HeadItem: action.HeadItem,
                    children: action.children,
                    isNoBackground: action.isNoBackground,
                    onClose: action.onClose,
                };
            }
            return data;
        }
        case 'backRightModal': {
            let data = {
                ...state,
            };
            data.cacheNext.push(data.activeModals);
            data.activeModals = data.cacheOld.pop();
            return data;
        }

        case 'nextRightModal': {
            let data = {...state};
            data.cacheOld.push(data.activeModals);
            data.activeModals = data.cacheNext.pop();
            return data;
        }

        case 'closeRightModal': {
            let data = {...state};
            data.activeModals = initialStateModal;
            data.activeExtraModals = initialStateModal;
            data.cacheOld = [];
            data.cacheNext = [];
            return data;
        }
        case 'openExtraModal': {
            let data = {...state};
            data.activeExtraModals = {
                isOpen: true,
                HeadItem: action.HeadItem,
                children: action.children,
                onClose: action.onClose,
            };
            return data;
        }
        case 'closeExtraModal': {
            let data = {...state};
            data.activeExtraModals = initialStateModal;
            return data;
        }
        default:
            return state;
    }
};